import type { SortEnum } from "@arbeidsark/shared"
import styled from "styled-components"
import type { CSSTextAlign, CSSTextTransform } from "~/types/css/rules"

export interface TableHeaderCellProps {
  sortedStatus?: SortEnum
  textTransform?: CSSTextTransform
  textAlign?: CSSTextAlign
  fontSize?: string
  fontWeight?: string | number
  color?: string
  lineHeight?: number
  display?: string
  highlight?: boolean

  borderRadius?: string

  height?: string
  width?: string
  minWidth?: string
  padding?: string
  cursor?: string
}

export const TableHeaderCell = styled.th<TableHeaderCellProps>`
  box-sizing: border-box;
  position: relative;

  text-transform: ${(props) => props.textTransform};
  font-size: ${(props) => props.fontSize};
  color: ${(props) =>
    props.highlight ? props.theme.colors.primary : props.theme.colors.gray50};
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  min-width: ${(props) => props.minWidth};
  padding: ${(props) => props.padding};
  font-weight: ${(props) => props.fontWeight};
  user-select: none;

  text-align: ${(props) => props.textAlign};
  line-height: ${(props) => props.lineHeight};
  border-radius: ${(props) => props.borderRadius};

  cursor: ${(props) => props.cursor};
`

TableHeaderCell.defaultProps = {
  textTransform: "uppercase",
  fontSize: "0.75rem",
  fontWeight: 400,
  color: "black",
  height: "60px",
  textAlign: "left",
  padding: "0  1.5625rem",
}
